import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import moment from 'moment';
import { Button, Stack } from '@mui/material';

export interface InventoryMovementProps {
  id: number;
  sku: string;
  occurred: string | null;
  executedBy: string | null;
  type: string | null;
  quantity: number;
  source: string | null;
  destination: string | null;
  fromStatus: string | null;
  toStatus: string | null;
  reference: string | null;
  status: string | null;
  errorMessage: string | null;
}

export const getColumns = (setStatus: Function): GridColDef[] => {
  return [
    {
      field: 'id',
      headerName: 'Id',
      flex: 1,
      minWidth: 90,
    },
    {
      field: 'sku',
      headerName: 'Sku',
      flex: 1,
      minWidth: 140,
    },
    {
      field: 'occurred',
      headerName: 'Date',
      flex: 1,
      minWidth: 70,
      valueFormatter: (params) => moment(params?.value).format('MMM-DD-YY'),
    },
    {
      field: 'executedBy',
      headerName: 'User',
      flex: 1,
      minWidth: 100,
    },
    {
      field: 'type',
      headerName: 'Type',
      flex: 1,
      minWidth: 180,
    },
    {
      field: 'source',
      headerName: 'From',
      flex: 1,
      minWidth: 80,
    },
    {
      field: 'destination',
      headerName: 'To',
      flex: 1,
      minWidth: 80,
    },
    {
      field: 'quantity',
      headerName: 'Qty',
      flex: 1,
      minWidth: 10,
    },
    {
      field: 'fromStatus',
      headerName: 'From Status',
      flex: 1,
      minWidth: 90,
    },
    {
      field: 'toStatus',
      headerName: 'To Status',
      flex: 1,
      minWidth: 90,
    },
    {
      field: 'reference',
      headerName: 'Reference',
      flex: 1,
      minWidth: 180,
    },
    {
      field: 'status',
      headerName: 'Sync Status',
      flex: 1,
      minWidth: 90,
    },
    {
      field: 'errorMessage',
      headerName: 'Sync Details',
      flex: 1,
      minWidth: 180,
    },
    {
      field: 'actions',
      flex: 1,
      renderCell: (param: GridRenderCellParams) => (
        <Stack direction="row" spacing={1} alignItems="center">
          {param.row.status !== 'Success' && param.row.status !== 'Pending' && (
            <Button variant="contained" size="small" onClick={() => setStatus(param.id, 0, param)}>
              Retry
            </Button>
          )}
          {param.row.status === 'Success' && (
            <Button variant="contained" size="small" onClick={() => setStatus(param.id, 0, param)}>
              Resubmit
            </Button>
          )}
          {param.row.status !== 'Success' && param.row.status !== 'Ignored' && (
            <Button variant="contained" size="small" onClick={() => setStatus(param.id, 3, param)}>
              Ignore
            </Button>
          )}
        </Stack>
      ),
      minWidth: 180,
    },
  ];
};
